import { render, staticRenderFns } from "./PollyReadingSpeed.vue?vue&type=template&id=33afbd13"
import script from "./PollyReadingSpeed.vue?vue&type=script&lang=ts"
export * from "./PollyReadingSpeed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports